import { render } from "./CreateAnnouncementView.vue?vue&type=template&id=7e18163a"
import script from "./CreateAnnouncementView.vue?vue&type=script&lang=js"
export * from "./CreateAnnouncementView.vue?vue&type=script&lang=js"

import "./CreateAnnouncementView.vue?vue&type=style&index=0&id=7e18163a&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__